import { render, staticRenderFns } from "./ShowProviderProduct.vue?vue&type=template&id=18179048"
import script from "./ShowProviderProduct.vue?vue&type=script&lang=js"
export * from "./ShowProviderProduct.vue?vue&type=script&lang=js"
import style0 from "./ShowProviderProduct.vue?vue&type=style&index=0&id=18179048&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports